import { grey } from '@mui/material/colors';
import { ReactComponent as CircleIcon } from '../../../assets/Icons/lucideIcons/circle.svg';
import { Tooltip } from '@mui/material';
import React from 'react';
import PropTypes from 'prop-types';

/**
 * @typedef HealthDefinition
 * @property {string} label
 * @property {string} color
 * @property {string} fail_reason
 */

/**
 * @type {import("react").FC<{ health: HealthDefinition, iconSize: string }>}
 */
const EntityHealthIndicator = ({ health, iconSize }) => {
  const label = health?.label || 'None';
  const color = health?.color || grey[500];
  const reason =
    health?.fail_reason || 'Entity does not satisfy any health definition.';

  return (
    <Tooltip
      title={`${label}: ${reason}`}
      slotProps={{
        popper: { placement: 'right' },
      }}
    >
      <CircleIcon
        style={{
          color,
          fill: color,
          stroke: color,
        }}
        width={iconSize ? parseInt(iconSize, 10) : 12}
        height={iconSize ? parseInt(iconSize, 10) : 12}
      />
    </Tooltip>
  );
};
EntityHealthIndicator.propTypes = {
  // @ts-ignore
  health: PropTypes.shape({
    label: PropTypes.string.isRequired,
    color: PropTypes.string.isRequired,
    fail_reason: PropTypes.string.isRequired,
  }).isRequired,
  iconSize: PropTypes.string,
};

export default EntityHealthIndicator;
